$(document).on('turbo:load', function () {
    const cannyCollector = $('.canny-collector');
    if (!cannyCollector.length) return;

    const renderCannyFallback = function () {
        cannyCollector.html(
            '<div class="text-center py-5">Unable to load the feature request form right now. Please try again later.</div>'
        );
    };

    $.get("/canny_widget_sso_token").done(function(data) {
        const cannyToken = data.token
        !function(w,d,i,s){
            function l(){
                if(!d.getElementById(i)){
                    var f=d.getElementsByTagName(s)[0],
                        e=d.createElement(s);e.type="text/javascript",
                        e.async=!0,
                        e.src="https://canny.io/sdk.js",
                        f.parentNode.insertBefore(e,f)
                }
            }
            if("function"!=typeof w.Canny){var c=function(){
                c.q.push(arguments)};
                c.q=[],
                w.Canny=c,
                "complete"===d.readyState?l():w.attachEvent?w.attachEvent("onload",l):w.addEventListener("load",l,!1)
            }
        }(window,document,"canny-jssdk","script");
        Canny('render', {
            boardToken: 'affab7c1-a5d4-11d5-898b-d2fed4df5ff2',
            basePath: null, // See step 2
            ssoToken: cannyToken, // See step 3,
            theme: 'light', // options: light [default], dark, auto
        });
    }).fail(function() {
        renderCannyFallback();
    });
});
